import styled from "styled-components";

export const NotificationItemContent = styled.div`
    display: flex;
    gap: 16px;

    margin-bottom: 8px;
`;
